define('app/sdc/tile/sdc-tile',["$compile", "service!sdc-tile-accent", "directive!sdc-tilt"], function ($compile, sdcTileAccentService) {
	return [{
		restrict: "AE",
		scope: false,
		priority: -1,
		terminal: true,
		template: null,
		link: ["$element", "$transclude", "$scope", "$attrs", function ($element, $transclude, $scope, $attrs) {
			$attrs.$addClass("sdc-tilt");
			$compile($element, null, -1)($scope, null, {
				parentBoundTranscludeFn: $transclude
			});
		}]
	}, {
		restrict: "AE",
		scope: false,
		priority: -2,
		template: null,
		controller: {
			bind: {
				"autoAccent": "@?",
				"accent": "@?",
				"autoMdHue": "@?"
			},
			constructor: ["$attrs", "$watch", function ($attrs, $watch) {
				var oldHue;
				if ("autoAccent" in $attrs) {
					$attrs.$observe("autoAccent", function (seed) {
						$attrs.$set("accent", sdcTileAccentService(seed));
					});
				}
				if ("autoMdHue" in $attrs) {
					$attrs.$observe("autoMdHue", function (seed) {
						$attrs.removeClass()
						$attrs.$set("accent", sdcTileHueService(seed));
					});
				}
			}]
		}
	}];
});
